import { merge as _merge } from 'lodash'
import it from 'core/translations/it'

export default _merge(it, {
  titles: {
    outbound_bthp: 'Outbound Certificato BTHP',
    sorting_details: 'Dettagli ventilazione'
  },
  simple_parcel_list: {
    to_read: 'Non letto',
    ok: 'Ok',
    force: 'Forza',
    force_parcel: 'Forza collo {{code}}',
    force_parcel_desc: 'Inserisci il PIN utente per forzare il collo',
    forced: 'Forzato',
    unexpected: 'Inatteso',
    remove: 'Rimuovi',
    invalid_pin: 'PIN utente non valido'
  },
  create_parcel_gate: {
    width: 'Larghezza',
    height: 'Altezza',
    depth: 'Profondità',
    tare: 'Tara',
    description: 'Descrizione'
  },
  misc: {
    verify_association: 'Verifica Associazione',
    delete_association: 'Elimina Associazione',
    sorted_quantity: 'Qt ventilata',
    sorted_date: 'Data ventilazione',
    upc: 'EAN',
    production_order_sku: 'EAN',
    item_po: 'Qty Commessa',
    item_order: 'Qty Carlav',
    item_row: 'Qty EAN13',
    unknown_tag: 'Tag Sconosciuto - contattare helpdesk Temera',
    invalid_tag: 'Tag Sconosciuto',
    work_order: 'Carlav'
  },
  error: {
    sorting_already_read: 'Articolo con seriale {{serial}} già ventilato nel gruppo {{group}}',
    sorting_no_group: 'Articolo da non ventilare',
    sorting_not_in_zone: "Articolo con seriale {{serial}} da non ventilare. L'articolo è nella zona {{zone}}",
    couldn_find_production_order_row: 'EAN13 errato per la riga commessa',
    WRONG_PLACE: 'Fornitore non abilitato'
  },
  serverError: {
    WRONG_ITEM_SUPPLIER: 'Rilevati item non associati al fornitore dichiarato.',
    QUANTITY_MISMATCH_ERROR: 'Quantità inserite non corrispondenti alle quantità rilevate.',
    ZONE_MISMATCH_ERROR: 'Zona inserita non corrispondente a quella rilevata.'
  },
  custom: {
    barcode: 'Barcode BC',
    barcodeBCTrim: 'Barcode BC trim',
    barcodeJDE: 'Barcode JDE',
    barcodeROQ: 'Barcode ROQ',
    barcodeROQTrim: 'Barcode ROQ trim',
    class: 'Classe',
    department: 'Dipartimento',
    dimensionSystem: 'Classe personalizzata',
    ean: 'EAN',
    eanIdPadre: 'EAN id padre',
    itemId: 'Item Id',
    stagioneROQ: 'Stagione ROQ',
    subclass: 'Sottoclasse',
    subdepartment: 'Sottodipartimento',
    variantType: 'Tipo variante',
    variantModel: 'Variante',
    cardCode: 'Cartellino',
    label: 'Etichetta',
    rfidEnabled: 'RFID abilitato',
    stato: 'Stato',
    ricondizionamentoFornitore: 'Fornitore ricondizionamento',
    codiceShelf: 'Codice scaffale',
    montante: 'Montante',
    ripiano: 'Ripiano',
    scaffale: 'Scaffale',
    model: 'Modello',
    sizeCode: 'Codice taglia',
    sizeDescription: 'Description taglia',
    serial: 'Seriale',
    identifier: 'Serial',
    product: 'Barcode BC',
    shift: 'Shift',
    destination: 'Destination',
    regDate: 'RegDate',
    listPosition: 'List position',
    list: 'List',
    customerName: 'Customer Name',
    regTime: 'RegTime',
    event: 'Event',
    customer: 'Customer',
    isCarryover: 'Carryover',
    carryoverValue: 'Carryover',
    madeIn: 'Made in',
    collectionCode: 'Collection',
    collectionDescription: 'Collection Description',
    collectionYear: 'Year',
    fatherProductValue: 'Father Product',
    genderValue: 'Gender',
    genderValueDescription: 'Gender Description',
    line: 'Brandline',
    lineDescription: 'Line Description',
    marchioDescription: 'Marchio Description',
    marchioValue: 'Marchio',
    merchandiseClassCode: 'Category',
    merchandiseClassDescription: 'Category Description',
    merchandiseSubclassCode: 'Sub-Category',
    merchandiseSubclassDescription: 'Sub-Category Description',
    modelPartColor: 'Model Part Color',
    modelPartColorSizeValue: 'Model Part Color Size',
    isPermanent: 'Permanent',
    permanentValue: 'Permanent',
    isSeasonal: 'Seasonal',
    seasonalValue: 'Seasonal',
    sleeveTypeValue: 'Sleeve Type',
    reference: 'Commessa',
    sender: 'Mittente',
    year: 'Anno',
    number: 'Numero',
    row: 'Riga',
    TAG_STATUS_CONFIRMED: 'Già associato',
    halfpair: 'Mezzo paio'
  },
  identifier_error: {
    UNKNOWN_TAG: 'Tag Sconosciuto - contattare helpdesk Temera',
    MISSING_SYSTEM_TAG: 'Tag Sconosciuto - contattare helpdesk Temera',
    MISSING_MANDATORY_TAG_DUAL: 'Tag obbligatorio mancante',
    KILLED_LOGICALLY_TAG: 'Tag logicamente ucciso',
    MISMACTH_GROUP_ID: 'ID gruppo non corrispondente',
    'Not Associated Tag': 'Tag non associato'
  }
})
